<template>
  <v-row align="center" justify="space-around">
    <v-btn
      class="w-100 mb-3 left custom-button pl-14"
      :class="
        bg_secondary_color
          ? 'subtitle-1 textOverSecondary--text py-10 secondary'
          : secondary
          ? 'subtitle-1 primary--text py-8 white'
          : 'primary title textOverPrimary--text py-10'
      "
      :disabled="disabled"
      rounded
    >
      <div class="mr-3">
        <icon
          v-if="custom_icon"
          :name="custom_icon"
          width="30"
          class="mr-3"
        ></icon>
        <v-icon left class="mr-7 pl-3" v-else>
          {{ icon }}
        </v-icon>
      </div>
      <div class="d-flex flex-column">
        <div>{{ label }}</div>
        <div v-if="disabled" class="text-caption text-left">
          <div v-if="msg_disabled">{{ msg_disabled }}</div>
          <div
            v-else
            style="white-space: nowrap; font-size: 12px"
            class="d-flex align-center"
          >
            <v-icon color="primary" style="font-size: 15px !important"
              >sync</v-icon
            >{{ $t("balance_refund.refund_pending") }}
          </div>
        </div>
      </div>
    </v-btn>
  </v-row>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    custom_icon: String,
    disabled: Boolean,
    msg_disabled: String,
    secondary: {
      type: Boolean,
      default: false,
    },
    bg_secondary_color: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style lang="css">
.custom-button {
  text-transform: none !important;
  box-shadow: none !important;
  max-width: 400px;
}
.custom-button i {
  font-size: 33px !important;
}
</style>
